﻿import React, { useEffect } from "react";
import { useState } from "react";
import { Typography, TextField, Grid, Autocomplete } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  selectEditCatalogData,
  selectIsEditMode,
  setCatalogDataField,
} from "@/features/connections/manageCatalogDataSlice";
import {
  defaultCode,
  blankCode,
} from "@/features/connections/integrationSlice";
import { AddEditCatalogPopup } from "./CatalogPopup";

const AddAllowanceChargePopup = ({ onClose, onValidate, onComplete }) => {
  const dispatch = useDispatch();
  const dataValues = useSelector(selectEditCatalogData);
  const isEdit = useSelector(selectIsEditMode);
  const [selectedIndicator, setIndicator] = useState(
    dataValues.Indicator ?? "",
  );

  useEffect(() => {
    if (
      selectedIndicator !== dataValues.Indicator &&
      dataValues.Indicator !== undefined
    ) {
      setIndicator(dataValues.Indicator);
    }
  }, [dataValues]);

  const handleIndicatorChange = (newIndicator) => {
    dispatch(
      setCatalogDataField({ name: "Indicator", value: newIndicator.value }),
    );
  };

  const validateForm = () => {
    if (onValidate) {
      const result = onValidate(dataValues);
      if (!result.isValid) return result;
    }
    if (!selectedIndicator) {
      return {
        isValid: false,
        message: "Please select a type indicator",
      };
    }
    if (dataValues.ACCode === defaultCode) {
      return {
        isValid: false,
        message: `AC Code cannot be saved as ${defaultCode}`,
      };
    }
    if (dataValues.ACCode === blankCode) {
      return {
        isValid: false,
        message: `AC Code cannot be saved as ${blankCode}`,
      };
    }
    if (dataValues.ACCode?.includes(",")) {
      return {
        isValid: false,
        message: `The AC Code cannot include a ','`,
      };
    }
    return { isValid: true };
  };

  const handleClose = () => {
    onClose();
    setIndicator("");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    dispatch(setCatalogDataField({ name, value }));
  };

  const options = [
    { label: "Allowance", value: "A" },
    { label: "Charge", value: "C" },
  ];

  return (
    <AddEditCatalogPopup
      onClose={handleClose}
      onValidate={validateForm}
      onComplete={onComplete}
    >
      <Grid item xs={4}>
        <Typography>
          Type Indicator{" "}
          <Typography
            component="span"
            sx={{ color: "red", fontSize: "1.2rem", fontWeight: "bold" }}
          >
            *
          </Typography>
        </Typography>
        <Autocomplete
          disabled={isEdit}
          options={options}
          isOptionEqualToValue={(option, value) => option.label === value}
          value={
            options.find((x) => x.value === selectedIndicator)?.label ?? ""
          }
          onChange={(e, newValue) => {
            handleIndicatorChange(newValue || null);
          }}
          renderInput={(params) => (
            <TextField
              sx={{ marginTop: 1, marginBottom: 2, maxWidth: 250 }}
              {...params}
              autoComplete="off"
            />
          )}
        />
      </Grid>
      <Grid item xs={4}>
        <Typography>AC Code </Typography>
        <TextField
          disabled={isEdit}
          variant="outlined"
          name="ACCode"
          value={dataValues?.ACCode || ""}
          onChange={handleChange}
          sx={{
            width: 250,
            marginTop: 1,
            marginBottom: 2,
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <Typography>Handling Code</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="HandlingCode"
            value={dataValues?.HandlingCode || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Description</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="ACCodeDescription"
            value={dataValues?.ACCodeDescription || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
    </AddEditCatalogPopup>
  );
};

export default AddAllowanceChargePopup;
